// Stylesheets
import "./theme.scss";
import "./resources/images/favicon.png";
console.log("[Theme] JS version 1");
// Components Javascript
// import "./components/animation/teaser-video-animations.js";
// import "./components/animation/teaser-icon-animations.js";
console.log("[Theme] Loading value-teaser-icon-animations.js");
import "./components/animation/value-teaser-icon-animations.js";
// console.log("[Theme] Loading general-teaser-icon-animations.js");
// import "./components/animation/general-teaser-icon-animations.js";
// console.log("[Theme] Loading chevron-animations.js");
// import "./components/animation/chevron-animations.js";
console.log("[Theme] Loading store-buttons.js");
import "./components/button/store-buttons.js";
console.log("[Theme] Loading general-teaser.js");
import "./components/teaser/general-teaser.js";
console.log("[Theme] Loading value-teaser.js");
import "./components/teaser/value-teaser.js";
console.log("[Theme] Loading ticker.js");
import "./components/ticker/ticker.js";
console.log("[Theme] Loading carousel.js");
import "./components/carousel/carousel.js";
console.log("[Theme] Loading negative-margin-image.js");
import "./components/image/negative-margin-image.js";
